import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import {
  ChangeDetectorRef,
  DestroyRef,
  PLATFORM_ID,
  inject
} from '@angular/core';

import { GlobalFacade } from '~backoffice/app/~store/facades/global.facade';
import { ConstantsService } from '~core/services/constants.service';
import { DialogService } from '../services/dialog.service';
import { ToastService } from '../services/toast.service';
import { LoggerService } from '~core/services/logger.service';
import { Permission } from '~core/models/roles.models';
import { AuthFacade } from '~backoffice/app/~store/facades/auth.facade';
import { map } from 'rxjs';
import { UserRole } from '~core/models/auth.models';
import { NgxPermissionsService } from 'ngx-permissions';
import { toSignal } from '@angular/core/rxjs-interop';
import { DashboardFacade } from '~backoffice/app/~store/facades/dashboard.facade';

export abstract class BaseComponent {
  protected _destroyRef = inject(DestroyRef);
  protected _cdRef = inject(ChangeDetectorRef);
  protected _globalFacade = inject(GlobalFacade);
  protected _authFacade = inject(AuthFacade);
  protected _dialogService = inject(DialogService);
  protected _platformId = inject(PLATFORM_ID);
  protected _constantsService = inject(ConstantsService);
  protected _toastService = inject(ToastService);
  protected _loggerService = inject(LoggerService);
  protected _dashboardFacade = inject(DashboardFacade);
  protected _permissionsService = inject(NgxPermissionsService);

  readonly permission = Permission;
  readonly userRole = UserRole;

  isSuperAdmin$ = this._authFacade.currentUser$.pipe(
    map(user => user?.roles.includes(UserRole.ROLE_SUPER_ADMIN))
  );

  permissions$ = this._permissionsService.permissions$;
  permissions = toSignal(this.permissions$);

  protected get _isPlatformBrowser(): boolean {
    return isPlatformBrowser(this._platformId);
  }

  protected get _isPlatformServer(): boolean {
    return isPlatformServer(this._platformId);
  }

  get environment(): ConstantsService['environment'] {
    return this._constantsService.environment;
  }

  get environment$(): ConstantsService['environment$'] {
    return this._constantsService.environment$;
  }

  get isSandboxEnvironment(): boolean {
    return this.environment.environmentVariant === 'sandbox';
  }

  // get isActiveLangFrench(): boolean {
  //   return this._translocoService.getActiveLang() === 'fr';
  // }
}
